<template>
    <div class="" v-if="$page.props.groupHasMembershipsAvailable">
        <table class="table">
            <thead>
                <tr>
                    <th class="w-64">Your Memberships</th>
                    <th># Available</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="membershipPlan in groupMembershipPlans">
                    <tr v-if="membershipPlan.available > 0">
                        <td>{{ membershipPlan.plan_title }}</td>
                        <td>
                            <div class="flex items-center gap-2">
                                <svg
                                    width="7"
                                    height="7"
                                    viewBox="0 0 7 7"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="3.5"
                                        cy="3.5"
                                        r="3.5"
                                        fill="#34A853"
                                    />
                                </svg>
                                <span>{{ membershipPlan.available }}</span>
                                <span>memberships</span>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>

    <div
        v-else
        class="flex flex-col gap-4 rounded border border-gray-350 bg-gray-250 p-8 text-center"
    >
        <div class="font-semibold">No Memberships Available</div>
        <div class="">
            You have 0 memberships available. Once you purchase memberships for
            EMTprep, you’ll be able to invite new students
        </div>
        <div class="">
            <group-buy-membership-modal></group-buy-membership-modal>
        </div>
    </div>
</template>
<script>
import GroupBuyMembershipModal from "@/Components/GroupBuyMembershipModal";

export default {
    name: "group-dashboard-memberships-overview",
    components: { GroupBuyMembershipModal },
    data() {
        return {
            groupHasMembershipsAvailable:
                this.$page.props.groupHasMembershipsAvailable,
            groupMembershipPlans: this.$page.props.groupMembershipPlans,
        };
    },
};
</script>
